export default __webpack_public_path__ + "static/media/img-time-s-slash.438593a5.svg";